import { render, staticRenderFns } from "./LuxIndex.vue?vue&type=template&id=39db5abb&scoped=true"
import script from "./LuxIndex.vue?vue&type=script&lang=js"
export * from "./LuxIndex.vue?vue&type=script&lang=js"
import style0 from "./LuxIndex.vue?vue&type=style&index=0&id=39db5abb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39db5abb",
  null
  
)

export default component.exports